import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface SettingsPageProps {
  onLogout: () => void;
  onBack?: () => void;
}

const SettingsPage: React.FC<SettingsPageProps> = ({ onLogout, onBack }) => (
  <Box sx={{ maxWidth: 400, mx: 'auto', mt: 8, p: 3, bgcolor: '#fff', borderRadius: 3, boxShadow: 2, position: 'relative' }}>
    {onBack && (
      <Button
        onClick={onBack}
        variant="text"
        size="small"
        sx={{ position: 'absolute', top: 8, left: 8, minWidth: 0, p: 1 }}
      >
        <CloseIcon sx={{ color: '#222', fontSize: 32 }} />
      </Button>
    )}
    <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 4, mt: 4, textAlign: 'center' }}>
      Settings
    </Typography>
    <Button
      onClick={onLogout}
      variant="contained"
      color="primary"
      fullWidth
      sx={{ py: 1.2, fontSize: '1.1rem', borderRadius: 8, backgroundColor: '#00A3FF', '&:hover': { backgroundColor: '#0091E6' }, mt: 2 }}
    >
      Log out
    </Button>
  </Box>
);

export default SettingsPage;
